import { api } from "./api";

export const viewSettingsApi = (params) => {
    return api.get(`/settings/view`, { params });
};

export const saveSettingsApi = (params) => {
    return api.post(`/settings/update`, JSON.stringify(params));
};

export const resetPasswordApi = (params) => {
    return api.post(`/settings/reset-password`, JSON.stringify(params));
};

export const uploadLogoApi = (params) => {
    return api.post(`/settings/upload-logo`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};